<h2>Этикетка ячейки</h2>
<form (ngSubmit)="print()" class="drop-padding" [formGroup]="formGroup">
  <mat-form-field appearance="outline">
    <mat-label>Склад</mat-label>
    <mat-select formControlName="warehouseId" [disabled]="loading || selectingPrinter">
      <mat-option *ngFor="let warehouse of warehouses" [value]="warehouse.id">
        {{ warehouse.description }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Ячейка</mat-label>
    <input
      matInput
      formControlName="cell"
      [readonly]="loading || selectingPrinter"
      [matAutocomplete]="cellOptions"
      placeholder="Например: 5M12"
      autocomplete="off"
    />
    <mat-autocomplete
      #cellOptions="matAutocomplete"
      (optionSelected)="selectCell($event.option.value)"
    >
      <mat-option *ngFor="let cell of cells" [value]="cell">{{ cell.code }}</mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <p class="profile-summary">Принтер и профиль этикетки выбранного склада. Новая ячейка будет создана при печати.</p>
  <p class="print-error" *ngIf="errorMessage" role="alert">{{ errorMessage }}</p>
  <div class="dialog-actions">
    <button mat-flat-button color="primary" type="submit"
      [disabled]="loading || selectingPrinter"
      (contextmenu)="printToOtherPrinter($event)"
      (keydown.shift.f10)="printToOtherPrinter($event)"
      title="Правый клик или Shift+F10 — выбрать агент печати">
      {{ loading ? 'Отправляем…' : selectingPrinter ? 'Выбираем агента…' : 'Печать' }}
    </button>
  </div>
</form>
